import { reportConstants } from "../constants/reportConstants";

const initialState = {
  sending: false,
  reportData: {},
  NoRecordMessage: "",
  error: "",
  fetching: "",
  MonthData: {},
  loading: false
};

export default function reportReducer(state = initialState, action) {
  switch (action.type) {
    case reportConstants.GET_PAST_MONTH_SALES_DATA_REQUEST:
      return {
         ...state, 
        loading: true
      };
    case reportConstants.GET_PAST_MONTH_SALES_DATA_SUCCESS:
      return {
        ...state,
        reportData: action.data,
        loading: false };
    case reportConstants.GET_PAST_MONTH_SALES_DATA_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case reportConstants.GET_REVENUE_SITE_DATA_REQUEST:
      return {
         ...state, 
        loading: true
      };
    case reportConstants.GET_REVENUE_SITE_DATA_SUCCESS:
      return {
        ...state,
        reportData: action.data,
        loading: false };
    case reportConstants.GET_REVENUE_SITE_DATA_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
      case reportConstants.GET_MONTH_REQUEST:
      return {
        ...state,
        loading: true
      };
    case reportConstants.GET_MONTH_SUCCESS:
      return {
        ...state,
        MonthData: action.responseData.data,
        loading: false
      };
    case reportConstants.GET_MONTH_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
      default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/reportReducer.js